module.exports = __webpack_public_path__ + "img/face.6075271f.png";